// extracted by mini-css-extract-plugin
export default {"wraper":"AboutPost_wraper__h7T1E","photo":"AboutPost_photo__0kOpE","box":"AboutPost_box__nb7VE","title":"AboutPost_title__5is8b","text":"AboutPost_text__uC05+"};